<template>
    <div id="roles_layout">
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else class="ui active centered inline large loader"></div>
        <div is="BackToTopButton"></div>
    </div>
</template>

<script>
import BackToTopButton from '@toolbox/back_to_top_button/main.vue'
export default {
    name: "RolesLayout",
    data: function() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    created: function() {
    },
    mounted: function() {
        var that = this;
        that.init();

        that.$bus.$off('init');
        that.$bus.$on('init', function(value = false) {
            that.init();
        }.bind(this));
    },
    beforeDestroy: function() {
        this.$bus.$off('init');
    },
    watch: {
    },
    methods: {
        init: async function() {
            var that = this;

            try {
                await new Promise(resolve => {
                    that.is_initialized = false;
                    resolve();
                });
                await that.$store.dispatch('provider/roles_module/fetch_permissions');
                await that.$store.dispatch('provider/roles_module/fetch_permission_groups');
                await new Promise(resolve => {
                    that.is_initialized = true;
                    that.$noty.information(
                        that.$t("ui.page_titles.roles") + ' ' +
                        that.$t('ui.general.initialize_complete')
                    , 300);
                    resolve();
                })
            } catch (err) {
                switch (err) {
                    case "Failed to fetch Permissions.":
                        that.$noty.error('無法取得 權限列表');
                        break;

                    case "Error to fetch Permissions.":
                        that.$noty.error('無法取得 權限列表，狀態異常');
                        break;

                    case "Failed to fetch PermissionGroups.":
                        that.$noty.error('無法取得 權限群組');
                        break;

                    case "Error to fetch PermissionGroups.":
                        that.$noty.error('無法取得 權限群組');
                        break;
                }
                that.is_initialized = true;
            }
        },
    },
    components: {
        BackToTopButton
    }
}
</script>
<style lang="scss">
    @import "../.assets/stylesheets/layout.scss";
</style>
